import React from "react";
import { GH_COLORS } from "./Style";

interface RoundBoxSelectProps {
  label: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  options: { value: string; label: string }[];
}

function RoundBoxSelect({
  label,
  value,
  onChange,
  options,
}: RoundBoxSelectProps) {
  return (
    <label
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 6,
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <span>{label}</span>
      <select
        value={value}
        onChange={onChange}
        style={{
          width: "100%",
          boxSizing: "border-box",
          borderRadius: 6,
          border: `1px solid ${GH_COLORS.border}`,
          padding: "8px 10px",
          fontSize: "14px",
          textAlign: "left",
          background: "#fff",
          color: GH_COLORS.fgDefault,
        }}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </label>
  );
}

export default RoundBoxSelect;
